<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-area section-space--ptb_90">
            <div class="container">
                <div class="row footer-widget-wrapper">
                    <div class="col-lg-4 col-md-6 footer-widget">
                        <div class="footer-widget__logo mb-30">
                            <router-link to="/">
                                <img src="../assets/img/logo/logo-dark.png" class="img-fluid logo-dark" alt="" loading="lazy">
                                <img src="../assets/img/logo/logo-dark.png" class="img-fluid logo-light" alt="" loading="lazy">
                            </router-link>
                        </div>
                        <ul class="footer-widget__list">
                            <li>Perpa Ticaret Merkezi B Blok Kat:9 No:1454</li>
                            <li>Okmeydanı/Şişli/İstanbul TURKEY</li>
                            <li><a href="mailto:info@barkodyazilimevi.com.tr" class="hover-style-link">info@barkodyazilimevi.com.tr</a></li>
                            <li><a href="tel:+905322412008" class="hover-style-link">0532 241 20 08</a></li>
                            <li><a href="#" class="hover-style-link hover-style-link--green">www.barkodyazilimevi.com.tr</a></li>
                        </ul>
                    </div>
                    <div class="col-lg-2 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20">{{ $t('whoweare') }}</h6>
                        <ul class="footer-widget__list">
                            <li><router-link to="/about" class="hover-style-link">{{ $t('about') }}</router-link></li>
                            <li><router-link to="/services" class="hover-style-link">{{ $t('services') }}</router-link></li>
                            <li><router-link to="/references" class="hover-style-link">{{ $t('references') }}</router-link></li>
                            <li><router-link to="/faq" class="hover-style-link">{{ $t('faq') }}</router-link></li>
                            <li><router-link to="/login" class="hover-style-link">{{ $t('login') }}</router-link></li>
                        </ul>
                    </div>
                    <div class="col-lg-2 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20">{{ $t('quicklinks') }}</h6>
                        <ul class="footer-widget__list">
                            <li><router-link to="/ik" class="hover-style-link">{{ $t('ik') }}</router-link></li>
                            <li><router-link to="/termsofuse" class="hover-style-link">{{ $t('termsofuse') }}</router-link></li>
                            <li><router-link to="/privacy" class="hover-style-link">{{ $t('privacy') }}</router-link></li>
                            <li><router-link to="/securepayment" class="hover-style-link">{{ $t('securepayment') }}</router-link></li>
                            <li><router-link to="/contacts" class="hover-style-link">{{ $t('contacts') }}</router-link></li>
                            <!-- <li><router-link to="/wheretofindus" class="hover-style-link">{{ $t('wheretofindus') }}</router-link></li>                             -->
                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 offset-lg-1 footer-widget">
                        <div class="twitter-feed-slider">
                            <div class="swiper-container twitter-feed-slider__container">
                                <div class="swiper-wrapper twitter-feed-slider__wrapper">
                                    <div class="swiper-slide twitter-feed-slider__single">
                                        <div class="tweet">
                                            <div class="tweet__text">
                                                "Karpin Mobil Yenilendi!" İşiniz için Hızlı ve Akıllı Çözümler..!
                                                <a href="https://apps.apple.com/tr/app/karpin-mobil/id6443685147?l=tr" target="_blank"><i class="fab fa-apple social-link-icon"></i> App Store {{$t('indir')}}</a>
                                                <a href="https://play.google.com/store/apps/details?id=com.karpin.mobile" target="_blank"><i class="fab fa-android social-link-icon"></i> GooglePlay {{$t('indir')}}</a>
                                                <b>#Karpin </b> <b>#KarpinERP </b> <b>#KarpinPOS </b> <b>#KarpinMobil </b> <b>#KarpinB2B </b> <b>#KarpinB2C </b> <b>#KarpinMRP </b> <b>#KarpinRobotic </b> <b>#KarpinSOLAR </b> <b>#forbusiness </b>
                                            </div>
                                            <div class="tweet__info">
                                                <h6 class="tweet__heading">Karpin</h6>
                                                <span class="tweet__date">Jun 07, 2022</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 text-center text-md-left">
                        <span class="copyright-text">Copyright © 1996-{{ new Date().getFullYear() }} <a href="https://www.barkodyazilimevi.com.tr" target="_blank" rel="nofollow">Karpin</a>, {{ $t('copyright') }}</span>
                    </div>
                    <!-- <span class="col-md-6 text-center text-md-center">
                        <span>En <strong>iyisiyle</strong> Çalıştığınızdan Emin Olmalısınız</span>
                        <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
                    </span> -->
                    <div class="col-md-6 text-center text-md-right">
                        <ul class="list ht-social-networks solid-rounded-icon">
                            <li class="item">
                                <a href="https://www.facebook.com/barkodyazilim" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="https://www.twitter.com/barkodyazilim" target="_blank" class="social-link"> <i class="fab fa-twitter social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="https://www.instagram.com/barkodyazilim" target="_blank" class="social-link"> <i class="fab fa-instagram social-link-icon"></i> </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"]
    }
</script>